import React, { useRef, useState } from "react";
import Call from "../../assets/icon/Call";
import Mail from "../../assets/icon/Email";
import Location from "../../assets/icon/Location";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";

const Contact = () => {
  const form = useRef();
  const [loader, setLoader] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setLoader(true);

    emailjs
      // .sendForm("service_oh11gdd", "template_89nk4e4", form.current, {
      //   publicKey: "vN4AP8HPVunnq2RVH",
      // })
      .sendForm("service_58qs7o9", "template_6u1rjfh", form.current, {
        publicKey: "fmBJAqheK-vMZGW4C",
      })
      .then(
        (result) => {
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.onmouseenter = Swal.stopTimer;
              toast.onmouseleave = Swal.resumeTimer;
            },
          });
          Toast.fire({
            icon: "success",
            title: "Email sent successfully!",
          });
          setLoader(false);
        },
        (error) => {
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.onmouseenter = Swal.stopTimer;
              toast.onmouseleave = Swal.resumeTimer;
            },
          });
          Toast.fire({
            icon: "error",
            title: "Failed to send message. Check the console for details.",
          });
          setLoader(false);
        }
      );
    e.target.reset();
  };

  return (
    <div className="pb-12 lg:pb-100">
      <div className="container">
        <div className="text-center pb-6 lg:py-60">
          <h3
            className="title pb-5 tab:pb-30 border-b border-border_sec wow animate__animated animate__fadeIn"
            data-wow-delay="0.2s"
          >
            Contact
          </h3>
        </div>
        <div className="flex gap-2 justify-between max-lg:items-center max-lg:flex-col-reverse">
          <form
            ref={form}
            onSubmit={sendEmail}
            className="grid gap-5 tab:gap-10 lg:max-w-[500px] w-full h-fit wow animate__animated animate__fadeInLeft"
          >
            <input required name="name" type="text" placeholder="Name" />

            <input required name="email" type="email" placeholder="Email" />

            <input
              required
              name="company"
              type="text"
              placeholder="Company name"
            />

            <input
              required
              name="number"
              type="number"
              placeholder="Phone number"
            />

            <input required name="comment" type="text" placeholder="Comment" />

            {loader ? (
              <button
                type="submit"
                className="w-full btn-primary btn-medium mt-2.5 flex items-center justify-center"
              >
                <div class="loader"></div>
              </button>
            ) : (
              <button
                type="submit"
                className="w-full btn-primary btn-medium mt-2.5"
              >
                Submit
              </button>
            )}
          </form>
          <div className="max-lg:border-t lg:border-r border-border_sec max-lg:w-full lg:h-[349px] lg:px-4 max-lg: max-lg:my-8"></div>
          <div className="lg:max-w-[500px] w-full wow animate__animated animate__fadeInRight">
            <h4 className="font-bold leading-none pb-30">Info</h4>
            <div className="grid gap-4">
              <div className="flex items-center gap-3">
                <div className="h-12 w-12 flex items-center justify-center border border-border_sec rounded-full bg-bg_first">
                  <Mail />
                </div>
                <a
                  href="mailto:info@guideproai.com"
                  className="text-gray text-base"
                >
                  info@guideproai.com
                </a>
              </div>
              {/* <div className="flex items-center gap-3">
                <div className="h-12 w-12 flex items-center justify-center border border-border_sec rounded-full bg-bg_first">
                  <Call />
                </div>
                <a href="tel:+1 317 500 3765" className="text-gray text-base">
                  +1 317 500 3765
                </a>
              </div> */}
              {/* <div className="flex items-center gap-3">
                <div className="h-12 w-12 flex items-center justify-center border border-border_sec rounded-full bg-bg_first">
                  <Location />
                </div>
                <p className="text-gray max-w-[calc(100%-60px)]">
                  4517 Washington Avenue, Near Central Park, Downtown Area,
                  Manchester, Kentucky 39495, United States.
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
